// Any application using the static head likely need the following
import { config } from '@fortawesome/fontawesome-svg-core';
import { cdnOrigin } from '@maxpreps/network/src/origins';
import NextHead from 'next/head';
import React from 'react';
import { IRequestContext } from '../../contexts/RequestContext';

config.autoAddCss = false;

export interface IStaticHeadProps {
  isAdmin?: boolean;
  requestContext?: IRequestContext;
}

const StaticHead: React.FC<IStaticHeadProps> = ({
  isAdmin,
  requestContext
}) => (
  <NextHead>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    {/* Never want to index an admin page */}
    {isAdmin && <meta name="robots" content="noindex" />}

    {requestContext && (
      <meta
        name="requestContext"
        // eslint-disable-next-line react/no-danger
        content={JSON.stringify(requestContext)}
      />
    )}
    <>
      {/* Assets */}
      {/* Yes, we want this twice - https://dev.to/crenshaw_dev/when-the-browser-can-t-take-a-preconnect-hint-6dn */}
      <link rel="preconnect" href={cdnOrigin} crossOrigin="anonymous" />
      <link rel="preconnect" href={cdnOrigin} />
    </>
  </NextHead>
);

export default React.memo(StaticHead);
